// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__HKUec","inner":"Form_inner__IqjdS","range":"Form_range__3y4uH","name":"Form_name__3_GnK","actions":"Form_actions__naWxG"};